import { useEffect, DependencyList } from 'react'

type EffectFunction = (isMounted: () => boolean) => Promise<unknown> | unknown
type DestroyFunction = (result?: unknown) => void

export default function useAsyncEffect(
  effect: EffectFunction,
  dependencies: DependencyList,
  destroy: DestroyFunction | null = null
) {
  const finalDependencies = [...(dependencies || [])]

  useEffect(function () {
    let result: unknown
    let mounted = true

    const maybePromise = effect(function () {
      return mounted
    })

    Promise.resolve(maybePromise).then(function (value: unknown) {
      result = value
    })

    return function () {
      mounted = false

      if (destroy != null) {
        destroy(result)
      }
    }
  }, finalDependencies)
}
